import React from 'react';
import { Bullet } from './bullet';
import { motion } from 'framer-motion';
import { AppContext } from '../../App';

const List = ({ data }) => {
  const context = React.useContext(AppContext);
  const animationConfig = context.config.animation;
  const containerAnimation = {
    hidden: {
      opacity: 1,
      scale: 0,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };
  const itemAnimation = {
    hidden: {
      y: 20,
      opacity: 0,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };

  return (
    <motion.div
      className={`st-list${data.fontBold ? ' font-bold' : ''}`}
      variants={containerAnimation}
      initial="hidden"
      animate="visible"
    >
      <h5 className="h5">{data.headline}</h5>
      {data.rows &&
        data.rows.map((row, index) => (
          <motion.div
            variants={itemAnimation}
            className="st-row"
            key={`${data.headline}-${index}`}
          >
            {row.bullet && <Bullet text={row.bullet} />}
            <span className="st-list-content">
              <span className="st-list-headline">{row.headline}</span>
              <span className="st-list-text">{row.text}</span>
            </span>
          </motion.div>
        ))}
    </motion.div>
  );
};

export { List };
